import MerchantOSSUploadApi from '@/api/merchant-oss-upload'
import { resolveOssPublicDownloadParams } from '@/libs/utils/oss-public-file'

const state = {
  publicDataHost: null
}

const mutations = {
  GET_PUBLIC_DATA_HOST: state => {
    return state.publicDataHost
  },
  SET_PUBLIC_DATA_HOST: (state, publicDataHost) => {
    state.publicDataHost = publicDataHost
  }
}

const actions = {
  async getUploadPublicSignedURL ({ commit }, {suffix, contentType}) {
    const result = await MerchantOSSUploadApi.getUploadPublicSignedURL(suffix, contentType)
    return result
  },
  async getPublicPresignedURL ({ commit }, path) {
    const result = await MerchantOSSUploadApi.getPublicPresignedURL(path)
    return result
  },
  async getUploadPrivateSignedURL ({ commit }, { suffix, contentType }) {
    const result = await MerchantOSSUploadApi.getUploadPrivateSignedURL(suffix, contentType)
    return result
  },
  async getPrivateSignedURL ({ commit }, {path, contentType}) {
    const result = await MerchantOSSUploadApi.getPrivateSignedURL(path, contentType)
    return result
  },
  async uploadFile ({ commit }, data) {
    const result = await MerchantOSSUploadApi.uploadFile(data.url, data.file)
    return result
  },
  async getPublicDataHost ({ commit }) {
    const publicDataHost = state.publicDataHost // await commit('GET_PUBLIC_DATA_HOST')
    if (publicDataHost) {
      return publicDataHost
    }
    const result = await MerchantOSSUploadApi.getPublicDataHost()
    if (result) {
      commit('SET_PUBLIC_DATA_HOST', result)
    }
    return result
  },
  async uploadPublicFile ({ dispatch, commit }, file) {
    const suffixArr = file.type.split('/')
    let suffix = ''
    if (suffixArr && suffixArr.length > 1) {
      suffix = suffixArr[1]
    }
    const result = await dispatch('getUploadPublicSignedURL', {suffix, contentType: file.type})
    const uploadResult = await dispatch('uploadFile', {
      url: result.signedURL,
      file: file
    })
    if (uploadResult.status === 200) {
      return result
    } else {
      throw new Error('上传失败')
    }
  },
  async uploadPrivateFile ({ dispatch, commit }, file) {
    const suffixArr = file.name.split('.')
    let suffix = ''
    if (suffixArr && suffixArr.length > 0) {
      suffix = suffixArr[suffixArr.length - 1]
    }
    const result = await dispatch('getUploadPrivateSignedURL', { suffix, contentType: file.type })
    const uploadResult = await dispatch('uploadFile', {
      url: result.signedURL,
      file: file
    })
    if (uploadResult.status === 200) {
      return result
    } else {
      throw new Error('上传失败')
    }
  },
  async getPublicDownloadURL ({ dispatch, commit }, params) {
    const result = await MerchantOSSUploadApi.getPublicDownloadURL(params)
    return result
  },
  /**
   * 打开/预览公网 OSS 文件：GET /merchant/oss/public/downloadurl
   * @param {*} raw FILE 字段或 OSS 路径
   */
  async openPublicFileUrl ({ dispatch }, raw) {
    const { path, filename } = resolveOssPublicDownloadParams(raw)
    if (!path || !filename) {
      throw new Error('无法解析文件路径')
    }
    return dispatch('getPublicDownloadURL', { path, filename })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-oss-upload.js